import { SugarMoneyApiCoinResponseType } from './coin';

export type PaginationParams = {
  page?: number;
};

export type SugarMoneyApiSearchCoinsRequestType = PaginationParams & {
  searchTerm: string;
  hideNsfw?: boolean;
};

export type SearchCoinType = {
  image_uri: string;
  mint: string;
  name: string;
  solPrice: string;
  symbol: string;
  coinMarketCap: number;
};

export type SugarMoneyApiSearchCoinsResponseType = {
  data: SearchCoinType[];
  nextPage: number | null;
  isMigratedToken: boolean;
  // TODO add total pagess
};

export type SugarMoneyApiCoinsResponseType = {
  coins: SugarMoneyApiCoinResponseType[];
  totalCount: number;
  page: number;
};

export enum SearchParamsFilterEnum {
  Discover = 'discover',
  New = 'new',
  Favorites = 'favorites',
}

export type SugarMoneyApiCoinsRequestType = PaginationParams & {
  filter: SearchParamsFilterEnum;
  bondingCurveFrom?: number;
  bondingCurveTo?: number;
  marketCapFrom?: number;
  marketCapTo?: number;
  coinAgeFrom?: number;
  coinAgeTo?: number;
  solPriceUsd?: number;
  toShow?: string;
  doNotShow?: string;
  coinHoldersFrom?: number;
  coinHoldersTo?: number;
  hideNsfw: boolean;
};
